import React from 'react';
import { Select } from 'antd';
import { useTranslation } from 'react-i18next';

const LanguageSwitcher = ({ compact }) => {
  const { i18n } = useTranslation();
  return (
    <Select
      value={i18n.language}
      onChange={(val) => i18n.changeLanguage(val)}
      options={[
        { label: compact ? 'EN' : 'English', value: 'en' },
        { label: compact ? 'FR' : 'Fran\u00e7ais', value: 'fr' },
      ]}
      style={{ width: compact ? 70 : 110 }}
      variant="borderless"
    />
  );
};

export default LanguageSwitcher;
